export default __webpack_public_path__ + "static/media/Massively Multiplayer.986bac89.svg";